module.exports = __webpack_public_path__ + "static/media/button-AddNewFamily.b15b5419.png";